import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// filter
import filter from './filter/'
for(let key in filter){
  Vue.filter(key, filter[key])
}

// 挂载api
import api from './api/'
Vue.prototype.api = api

// 挂载util
import util from './util/'
Vue.prototype.util = util

// 工具
// copy
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);


//moment
import moment from 'moment';
Vue.prototype.$moment = moment


import toastRegistry from './vendor/toast/index'
Vue.use(toastRegistry)

import '@/assets/css/bootstrap.css'
import '@/assets/css/main.scss'


// import echarts from 'echarts'
//
// Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
